import React, { useState, useRef, useEffect } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
} from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiTableSearch from "../../controls/MuiTableSearch";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Import AntD
import { Modal } from "antd";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { original, unwrapResult } from "@reduxjs/toolkit";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import from uomSlice.js
import {
  addUoMToServer,
  deleteUoMFromServer,
  getUoMCountFromServer,
  getUoMFromServer,
  getUoMFromServerByPagination,
  updateUoMInServer,
} from "./uomSlice";

//Import CSS
import "./uom.css";

const UoM = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const signInUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signInUser);
  const [showFieldsContainer, setShowFieldsContainer] = useState(false);
  const [uomId, setUoMId] = useState(0);
  const [uomCode, setUoMCode] = useState("");
  const [uomName, setUoMName] = useState("");
  const [buttonSave, setButtonSave] = useState("Save");
  const [uomList, setUoMList] = useState([]);
  const [originalUoMList, setOriginalUoMList] = useState([]); // I have used this hook for handling Table Data search.
  const [uomCount, setUoMCount] = useState(0);
  const [tableDataSearch, setTableDataSearch] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // const [preventTableDataRendering, setPreventTableDataRendering] =
  //   useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //End useState

  //useRef
  const uomCodeRef = useRef(null);
  const uomNameRef = useRef(null);
  const saveRef = useState(null);
  const cancelRef = useState(null);
  const clearRef = useState(null);
  //End useRef

  const fetchDatasByPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getUoMFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
      }
      if (Array.isArray(unwrappedResult.data)) setUoMList(unwrappedResult.data);
    } catch (error) {
      console.log({ ErrorOccured: error });
      setNotify({
        isOpen: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => setLoginUser(result.data));
    }

    const fetchDatas = async () => {
      try {
        const uomListResult = await dispatch(getUoMFromServer());
        const unwrappedResult = unwrapResult(uomListResult);
        if (unwrappedResult.data.length > 0) {
          setOriginalUoMList(unwrappedResult.data);
        }

        const uomCountResult = await dispatch(getUoMCountFromServer());
        const unwrappedUoMCountResult = unwrapResult(uomCountResult);
        unwrappedUoMCountResult.data[0].UoMCount === undefined
          ? setUoMCount(0)
          : setUoMCount(unwrappedUoMCountResult.data[0].UoMCount);
      } catch (error) {
        console.log({ ErrorOccured: error });
        setNotify({
          isOpen: true,
          message: error.message,
          severity: "error",
        });
      }
    };

    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);

  useEffect(() => {
    fetchDatasByPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleAdd = (e) => {
    e.preventDefault();
    setShowFieldsContainer(true);
    resetfields();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    let trimmedUoMCode = uomCode.trim();
    let trimmedUoMName = uomName.trim();
    if (trimmedUoMCode === "") {
      setNotify({
        isOpen: true,
        message: "UoM Code is required",
        severity: "warning",
      });
      uomCodeRef.current.focus();
      return;
    } else if (trimmedUoMName === "") {
      setNotify({
        isOpen: true,
        message: "UoM Name is required",
        severity: "warning",
      });
      uomNameRef.current.focus();
      return;
    } else {
      let newUoM = {
        uomCode: trimmedUoMCode,
        uomName: trimmedUoMName,
        loginUser,
      };
      await dispatch(addUoMToServer(newUoM))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else if (result.flag === 2) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "warning",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((error) => {
          console.log({ ErrorOccured: error });
          setNotify({
            isOp: true,
            message: error.message,
            severity: "error",
          });
        });

      await dispatch(getUoMCountFromServer())
        .then(unwrapResult)
        .then((result) => {
          setUoMCount(result.data[0].UoMCount);
        })
        .catch((error) => {
          console.log({ ErrorOccured: error });
          setNotify({
            isOp: true,
            message: error.message,
            severity: "error",
          });
        });

      await fetchDatasByPagination(page + 1, rowsPerPage);

      resetfields();
      uomCodeRef.current.focus();
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetfields();
    setShowFieldsContainer(false);
    setButtonSave("Save");
  };

  const handleClear = (e) => {
    e.preventDefault();
    resetfields();
    uomCodeRef.current.focus();
  };

  const resetfields = () => {
    setUoMId(0);
    setUoMCode("");
    setUoMName("");
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    {
      id: "Id",
      label: "Id",
      hideable: true,
      minWidth: 170,
    },
    { id: "UCode", label: "Code", minWidth: 170 },
    { id: "UName", label: "Name", minWidth: 100 },
  ];

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleEdit = (uom) => {
    setShowFieldsContainer(true);
    setUoMId(uom.Id);
    setUoMCode(uom.UCode);
    setUoMName(uom.UName);
    showFieldsContainer
      ? uomCodeRef.current.focus()
      : setShowFieldsContainer(true);
    setButtonSave("Update");
  };

  const handleUpdate = async () => {
    let trimmedUoMCode = uomCode.trim();
    let trimmedUoMName = uomName.trim();
    if (trimmedUoMCode === "") {
      setNotify({
        isOpen: true,
        message: "UoM Code is required",
        severity: "warning",
      });
      uomCodeRef.current.focus();
      return;
    } else if (trimmedUoMName === "") {
      setNotify({
        isOpen: true,
        message: "UoM Name is required",
        severity: "warning",
      });
      uomNameRef.current.focus();
      return;
    } else {
      let updatedUoM = {
        uomCode: trimmedUoMCode,
        uomName: trimmedUoMName,
        loginUser,
      };

      await dispatch(updateUoMInServer({ ...updatedUoM, uomId }))
        .then(unwrapResult)
        .then((result) => {
          if (result.flag === 1) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "success",
            });
          } else if (result.flag === 2) {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "warning",
            });
          } else {
            setNotify({
              isOpen: true,
              message: result.message,
              severity: "error",
            });
          }
        })
        .catch((error) => {
          console.log({ ErrorOccured: error });
          setNotify({
            isOpen: true,
            message: error.message,
            severity: "error",
          });
        });

      // await dispatch(getUoMCountFromServer())
      // .then(unwrapResult)
      // .then((result) => {
      //   setUoMCount(result.data[0].UoMCount);
      // })
      // .catch((err) => console.log({ objError: err }));

      await fetchDatasByPagination(page + 1, rowsPerPage);

      resetfields();
      uomCodeRef.current.focus();
      setButtonSave("Save");
    }
  };

  const handleDelete = async (uomid) => {
    resetfields();
    setButtonSave("Save");
    confirm({
      title: "Are you sure to delete this uom?",
      // content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        await dispatch(deleteUoMFromServer({ uomid, loginUser }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((error) => {
            console.log({ ErrorOccured: error });
            setNotify({
              isOpen: true,
              message: error.message,
              severity: "error",
            });
          });

        await dispatch(getUoMCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setUoMCount(result.data[0].UoMCount);
          })
          .catch((error) => {
            console.log({ ErrorOccured: error });
            setNotify({
              isOpen: true,
              message: error.message,
              severity: "error",
            });
          });

        // console.log(page);
        let currentPage = parseInt(page + 1);
        // console.log(currentPage);
        // console.log(rowsPerPage);
        // console.log(originalUoMList.length);
        const newTotalRecords = uomCount - 1;
        // console.log(newTotalRecords);
        const totalPages = Math.ceil(newTotalRecords / rowsPerPage); // rowcount
        // console.log(totalPages);
        if (currentPage > totalPages) {
          // console.log(Math.max(totalPages - 1, 0));
          setPage(Math.max(totalPages - 1, 0)); // Ensures the page is at least 0
          await fetchDatasByPagination(page, rowsPerPage);
        } else {
          await fetchDatasByPagination(page + 1, rowsPerPage);
        }
        showFieldsContainer
          ? uomCodeRef.current.focus()
          : setShowFieldsContainer(false);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasByPagination(page + 1, rowsPerPage);
      return;
    } else {
      const filteredRows = originalUoMList.filter((uom) => {
        return (
          uom.UName.toLowerCase().includes(searchedVal.toLowerCase()) ||
          uom.UCode.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setUoMList(filteredRows);
    }
  };

  return (
    <>
      <Box className="uomboxcontainer">
        <Alert notify={notify} setNotify={setNotify} />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: "5px" }}
        >
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdd}
              sx={{ mb: "5px" }}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleRefresh}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Refresh
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", mt: "-13px" }}
          >
            <MuiTableSearch
              placeholder="Search UoM"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
        </Grid>
        {showFieldsContainer ? (
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            <h6>Add UoM</h6>
            <Divider />
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="uomcode"
                    label="UoM Code *"
                    onChange={(e) => {
                      setUoMCode(e.target.value);
                    }}
                    value={uomCode}
                    inputRef={uomCodeRef}
                    autoComplete="off"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="uomname"
                    label="UoM Name *"
                    onChange={(e) => {
                      setUoMName(e.target.value);
                    }}
                    value={uomName}
                    inputRef={uomNameRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        uomCodeRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  {buttonSave === "Save" ? (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnsave"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          uomNameRef.current.focus();
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnupdate"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          uomNameRef.current.focus();
                      }}
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    className="btncancel"
                    variant="contained"
                    size="small"
                    ref={cancelRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        saveRef.current.focus();
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    variant="contained"
                    size="small"
                    className="btnclear"
                    ref={clearRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        cancelRef.current.focus();
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        ) : (
          ""
        )}
      </Box>

      <Box
        className="uomboxcontainer"
        sx={showFieldsContainer ? { mt: 3 } : { mt: 0 }}
      >
        <Paper elevation={2} sx={{ p: 2 }}>
          <TableContainer sx={{ maxHeight: 1000 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      hidden={column.id === "Id" ? true : false}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {uomList.length > 0 ? (
                  uomList.map((uom) => (
                    <TableRow key={uom.Id}>
                      <TableCell>
                        <EditIcon
                          className="editicon"
                          fontSize="medium"
                          onClick={() => handleEdit(uom)}
                        />
                        <DeleteIcon
                          className="deleteicon"
                          fontSize="medium"
                          onClick={() => handleDelete(uom.Id)}
                        />
                      </TableCell>
                      <TableCell hidden={true}>{uom.Id}</TableCell>
                      <TableCell>{uom.UCode}</TableCell>
                      <TableCell>{uom.UName}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No UoM found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className="MuiTablePagination-selectLabel"
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={uomCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};

export default UoM;
